export const formatNumber: (
    options?: Intl.NumberFormatOptions | undefined,
) => (value: number | bigint) => string = (opts) => (value) => {
    return new Intl.NumberFormat("nb", opts).format(value);
};
